/**
 * Сервис для работы с Meal Monitor API
 */

import { apiService } from './api';
import type { MealMonitorCodeResponse, MealMonitorStatus, DailyMealReport } from '../types/mealMonitor';

class MealMonitorService {
  /**
   * Генерирует код подключения для клиента
   */
  async generateCode(clientId: number): Promise<MealMonitorCodeResponse> {
    try {
      const response = await apiService['client'].post<MealMonitorCodeResponse>(
        `/clients/${clientId}/meal-monitor/generate-code`
      );
      return response.data;
    } catch (error: any) {
      throw error;
    }
  }

  /**
   * Проверяет статус подключения Meal Monitor
   */
  async checkStatus(clientId: number): Promise<MealMonitorStatus> {
    try {
      const response = await apiService['client'].get<MealMonitorStatus>(
        `/clients/${clientId}/meal-monitor/status`
      );
      return response.data;
    } catch (error: any) {
      throw error;
    }
  }

  /**
   * Получает записи о питании за указанную дату
   */
  async getEntries(clientId: number, date?: string): Promise<DailyMealReport> {
    try {
      const params = date ? { date_str: date } : {};
      const response = await apiService['client'].get<DailyMealReport>(
        `/clients/${clientId}/meal-monitor/entries`,
        { params }
      );
      return response.data;
    } catch (error: any) {
      throw error;
    }
  }

  /**
   * Отключает интеграцию с Meal Monitor
   */
  async disconnect(clientId: number): Promise<{ success: boolean; message: string }> {
    try {
      const response = await apiService['client'].delete<{ success: boolean; message: string }>(
        `/clients/${clientId}/meal-monitor/disconnect`
      );
      return response.data;
    } catch (error: any) {
      throw error;
    }
  }
}

export const mealMonitorService = new MealMonitorService();
